import { ChipColors } from '../../../components/designSystem/Chip/Chip.types';

export const getChipColorByMatchesCount = (count: number) => {
  if (count === 0) {
    return ChipColors.Alert;
  } else if (count <= 3) {
    return ChipColors.Warning;
  } else {
    return ChipColors.Success;
  }
};
